export const HUB_SOURCE_PARAM = 'ideagen_hub_source';

/**
 * True when the current URL carries the Hub tile marker, indicating the SPA was opened from an
 * Ideagen Hub tile and should authenticate via the Hub sign-in entry point rather than the normal
 * login funnel.
 */
export function hasHubSourceMarker(): boolean {
  const params = new URLSearchParams(window.location.search);
  return params.get(HUB_SOURCE_PARAM)?.toLowerCase() === 'true';
}

/**
 * Builds the redirect target for the Hub sign-in entry point on the omnis origin, carrying the
 * marker and a validated ReturnUrl back to the current page (with the marker stripped, so a later
 * session expiry on the landed page takes the normal login path). The ReturnUrl must be absolute —
 * the backend's RedirectUrlValidator only trusts a ReturnUrl whose parsed host matches the request
 * host or its whitelist, and treats anything non-absolute as invalid.
 */
export function getHubLoginUrl(): string {
  const returnUrl = getCleanReturnUrl();
  return `${window.location.origin}/security/hub-login?${HUB_SOURCE_PARAM}=true&ReturnUrl=${encodeURIComponent(returnUrl)}`;
}

function getCleanReturnUrl(): string {
  const url = new URL(window.location.href);
  url.searchParams.delete(HUB_SOURCE_PARAM);
  const search = url.searchParams.toString();
  return `${url.origin}${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
}
